import { API_SERVICE } from "@/services/api.service";

export default {
    namespaced: true,
    state :{
        companyDetails: null,
        companyTheme : null,
        accountTheme : null,
        companyUrls : null,
        accountUrls : null,
        shortName : null,
        currencyInfo: null
    },
    mutations:{
        SET_COMPANY_DETAILS(state,data){
            document.title = `myProp - ${data.MarketingName}`;
            state.companyDetails = data;
        },
        SET_COMPANY_THEME(state, data){
            state.companyTheme = data
        },
        SET_ACCOUNT_THEME(state, data){
            state.accountTheme = data
        },
        SET_COMPANY_URLS(state, data){
            state.companyUrls = data
        },
        SET_ACCOUNT_URLS(state, data){
            state.accountUrls = data
            // Account URLs set
        },
        SET_COMPANY_SHORTNAME(state, data){
            state.shortName = data;
        },
        SET_CURRENCY_INFORMATION(state, data){
            state.currencyInfo = data
            localStorage.setItem('currencyInfo', JSON.stringify(state.currencyInfo));  
        },
        RESET_COMPANY_STATE(state){
            state.companyDetails = null;
            state.companyTheme = null;
            state.accountTheme = null;
            state.companyUrls = null;
            state.accountUrls = null;
            state.shortName = null;
            state.currencyInfo = null;
            document.title = 'myProp';
        },
        RESET_VUETIFY_THEME(state, vuetifyInstance){
            // Reset to default theme colors
            if (vuetifyInstance && vuetifyInstance.theme && vuetifyInstance.theme.themes.defaultTheme) {
                vuetifyInstance.theme.themes.defaultTheme.colors.primary = '#ffffff';
                vuetifyInstance.theme.themes.defaultTheme.colors.secondary = '#595959';
                vuetifyInstance.theme.themes.defaultTheme.colors.tertiary = '#f0f0f0';
                vuetifyInstance.theme.themes.defaultTheme.colors.title = '#9e9e9e';
                vuetifyInstance.theme.themes.defaultTheme.colors.featureHighlight = '#9e9e9e';
                vuetifyInstance.theme.themes.defaultTheme.colors.fontColor = '#36454F';
                vuetifyInstance.theme.themes.defaultTheme.colors.accent = '#9e9e9e';
            }
        }
    },
    getters:{
        shortName(state){
            return state.shortName;
        },
        companyTheme(state){
            return state.companyTheme
        },
        accountTheme(state){
            return state.accountTheme
        },
        companyUrls(state){
            return state.companyUrls
        },
        accountUrls(state){
            return state.accountUrls
        },
        currencyInfo(state){
            let currencyInfo = state.currencyInfo;
            if(currencyInfo === null){
                if (localStorage.getItem('currencyInfo')) {
                    currencyInfo = JSON.parse(localStorage.getItem('currencyInfo'))
                }
            }
            return currencyInfo
        },
        companyDetails(state){
            return state.companyDetails
        }
    },
    actions:{
        getCurrencyInformation({commit, state}){
            const params = {body: {
                clientName : state.shortName             
            }}
            API_SERVICE.post("peoplePortalRestAPI", "/company/currency", params).then((res) => {
                if(res.status === "200"){

                    commit("SET_CURRENCY_INFORMATION", res.data)
                }
            })
        },
        getCompanyUrlsGeneric({commit, state}){
            const params = {body: {
                clientName : state.shortName             
            }}
            API_SERVICE.post("peoplePortalRestAPI", "/company/urls/generic", params).then((res) => {
                if(res.status === "200"){
                    commit("SET_ACCOUNT_URLS", res.data)
                }
            })
        },
        async searchItems({rootGetters} , payload){
            return new Promise((resolve) => { 
            const params = {
                    body: {
                        clientName : rootGetters['companyStore/shortName'],
                        payload : payload
                    }
                }
                API_SERVICE.post("peoplePortalRestAPI", "/company/search", params).then((res) => {
                    if(res.status === "200"){
                        // Search completed
                        resolve({
                            searchSuccess : true,
                            data : res.data,
                        })
                    }
                    else{
                        resolve({
                            searchSuccess : false,
                        })
                    }
                }).catch(() => {
                    resolve({
                        searchSuccess : false,
                    })
                })
            })
        },
        resetCompanyStateAndTheme({commit}, vuetifyInstance){
            commit('RESET_COMPANY_STATE');
            if (vuetifyInstance) {
                commit('RESET_VUETIFY_THEME', vuetifyInstance);
            }
        }
    }
}